import React from 'react';
import { Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import manualReducer from './reducers';

const virtualDeviceImport = () => import(/* webpackChunkName: "manual-virtual-device" */ './ducks/liveSessionManager/containers/VirtualSessionContainer');
const realDeviceImport = () => import(/* webpackChunkName: "manual-real-device" */ './components/MobileManualSession');

const ManualFullscreenRoutes = () => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        load={realDeviceImport}
        path="/live/mobile/dataCenters/:dataCenterId/devices/:deviceId"
      />
      <BundleRoute
        load={virtualDeviceImport}
        path="/live/lsm/:sessionId?"
      />
    </Switch>
  </LoginRequiredContainer>
);

export default dynamic(
  'apps.manual', attachReducer(manualReducer),
)(ManualFullscreenRoutes);
